module.exports = __webpack_public_path__ + "static/media/freezvix-logo.7d08048a.jpg";